<script>
  import { writable } from "svelte/store";
  import { navigate } from "../router";
  import { getUser } from "../user.js";
  import { onMount } from "svelte";
  import { load, create, refresh_count } from "../guest.js";
  import { loadAll as loadLabels, getLabels } from "../labels.js";
  import { Background, Font, Padding } from "../component/modifier";
  import { HStack, VStack, Spacer } from "../component/layout";
  import CookieConsent from "../component/CookieConsent.svelte";
  import Header from "../component/Header.svelte";
  import Copyright from "../component/Copyright.svelte";
  import GuestsList from "../component/GuestsList.svelte";
  import GuestForm from "../component/GuestForm.svelte";
  import { BOOL } from "../dico.js";
  import { Icon, Button, Label, Text, CheckList, Toggle } from "../component/widget";

  export let wedding_guid;

  let isListView = true;
  let isGraphView = false;
  let isAddGuest = false;

  let current = "";

  let showError = false;
  let errorMessage = null;

  /* Filters */
  let LABELS = getLabels();
  let search = null;
  let label = new Array($LABELS.length);
  let attending = new Array(BOOL.length);
  let food_restriction = false;

  let guests = [];
  let filtered_guests = writable([]);
  let guests_count = writable({
    total: {
      attending: 0,
      count: 0,
    },
    adult: {
      attending: 0,
      count: 0,
    },
    teen: {
      attending: 0,
      count: 0,
    },
    child: {
      attending: 0,
      count: 0,
    },
    baby: {
      attending: 0,
      count: 0,
    },
  });

  let created_id = null;

  function showListView() {
    isListView = true;
    isGraphView = false;
  }

  function showGraphView() {
    isListView = false;
    isGraphView = true;
  }

  function filter(guests, search, label, attending, food_restriction) {
    let filtered_labels = $LABELS.filter((l, i) => label[i]).map((l) => l.id);
    let filtered_attending = BOOL.filter((l, i) => attending[i]).map((l) => l.id);

    filtered_guests.set(
      guests.filter((group) => {
        return (
          (!search ||
            group.some((g) => {
              let s = search.toLowerCase().trim();
              return (
                g.name.toLowerCase().includes(s) ||
                g.email.toLowerCase().includes(s) ||
                g.firstname.toLowerCase().includes(s) ||
                g.lastname.toLowerCase().includes(s)
              );
            })) &&
          (filtered_labels.length == 0 ||
            group[0].groupLabels.some((l) => filtered_labels.includes(l.id)) ||
            group.some((g) => {
              return g.labels.some((l) => filtered_labels.includes(l.id));
            })) &&
          (filtered_attending.length == 0 ||
            group.some((g) => {
              return filtered_attending.includes(g.is_attending);
            })) &&
          (!food_restriction ||
            group.some((g) => {
              console.log(g.food_restriction);
              return g.food_restriction;
            }))
        );
      })
    );
  }

  $: filter(guests, search, label, attending, food_restriction);

  let userRequest;

  onMount(() => {
    console.log("Guests on mount");
    userRequest = getUser();

    const unsubscribe = userRequest.subscribe((promise) => {
      promise
        .then((u) => {
          refresh();
        })
        .catch((e) => {
          navigate("/");
        });
    });

    return () => {
      console.log("Guests destroy");
      unsubscribe();
    };
  });

  const submit = async (firstname, lastname, email, age, gender, age_val) => {
    let r = await create(wedding_guid, firstname, lastname, email, age, gender, age_val);
    created_id = r.data.id;
    refresh();
  };

  const cancel = () => {
    isAddGuest = false;
  };

  const countInGroup = (group, attr) => {
    return group.filter((g) => g[attr]).length;
  };

  const countValueInGroup = (group, attr, value) => {
    return group.filter((g) => g[attr] == value).length;
  };

  const refresh = async () => {
    guests_count.set(await refresh_count(wedding_guid));

    try {
      let labels_guests = await loadLabels(wedding_guid);
      let labels_invitations = await loadLabels(wedding_guid, true);

      load(wedding_guid)
        .then((r) => {
          r.forEach((i) => {
            i[0].isOpened = created_id == i[0].invitation_id;
            if (i.length > 0) {
              i[0].groupLabels = labels_invitations[i[0].invitation_id] || [];
            }
            i.forEach((g) => {
              g.labels = labels_guests[g.id] || [];
            });
          });
          guests = r;
          isAddGuest = false;
        })
        .catch((e) => {
          console.log(e);
          guests = [];
        });
    } catch (e) {
      console.log(e);
    }
  };
</script>

<main>
  <CookieConsent />
  <Header>
    <div slot="left">
      <Button action={() => navigate(`#/dashboard/${wedding_guid}`)}>
        <Label text="Dashboard" icon="tachometer-alt" borderLeft h="48px" />
      </Button>
    </div>
  </Header>
  <Background color="white">
    <HStack grow alignment="stretch">
      <div class="menu">
        <VStack alignment="center">
          <Background color="var(--primary-dark-color)">
            <Padding>
              <Font name="Cinzel" size="1.5em">
                <Label
                  text="Liste d'invités"
                  iconSize="48"
                  icon="images/invites.svg"
                  fa={false}
                  color="var(--secondary-light-color)"
                  h="48px" />
              </Font>
            </Padding>
          </Background>
          <Padding>
            <Icon
              name="list"
              size="80"
              selected={isListView}
              on:click={showListView}
              cursor="pointer" />
          </Padding>
          <Spacer minSpacing="10px" />
          <Padding>
            <Icon
              name="chart-pie"
              size="80"
              selected={isGraphView}
              on:click={showGraphView}
              cursor="pointer" />
          </Padding>
          <Spacer minSpacing="10px" />
          <Padding>
            <VStack>
              <p>
                Invités présents&nbsp;:
                <span>{`${$guests_count.total.attending} / ${$guests_count.total.count}`}</span>
              </p>
              <Padding top="0">
                <HStack alignment="center">
                  <Label
                    text={`${$guests_count.adult.attending} / ${$guests_count.adult.count} Adulte(s)`}
                    icon="restroom"
                    noshrink />
                </HStack>
              </Padding>
              <Padding top="0">
                <HStack alignment="center">
                  <Label
                    text={`${$guests_count.teen.attending} / ${$guests_count.teen.count} Ado(s)`}
                    fa={false}
                    icon="images/cap.svg"
                    noshrink />
                </HStack>
              </Padding>
              <Padding top="0">
                <HStack alignment="center">
                  <Label
                    text={`${$guests_count.child.attending} / ${$guests_count.child.count} Enfant(s)`}
                    icon="child"
                    noshrink />
                </HStack>
              </Padding>
              <Padding top="0">
                <HStack alignment="center">
                  <Label
                    text={`${$guests_count.baby.attending} / ${$guests_count.baby.count} Bébé(s)`}
                    icon="baby"
                    noshrink />
                </HStack>
              </Padding>
            </VStack>
          </Padding>
        </VStack>
      </div>
      <article>
        {#if isListView}
          <HStack alignment="center">
            <div class="search">
              <Text
                id={"search"}
                reset
                bind:value={search}
                icon="fas fa-search"
                label="Search"
                placeholder="Rechercher"
                margin={false}
                bind:current />
            </div>
            <CheckList
              id="label"
              reset
              bind:value={label}
              icon="fas fa-tag"
              values={$LABELS}
              label="Label"
              margin={true}
              bind:current />
            <CheckList
              id="attending"
              reset
              bind:value={attending}
              icon="fas fa-glass-cheers"
              values={BOOL}
              label="Présent"
              margin={true}
              bind:current />
            <Toggle action={() => (food_restriction = !food_restriction)}>
              <Label icon="utensils" />
            </Toggle>
          </HStack>

          {#if isAddGuest}
            <GuestForm {submit} {cancel} bind:show={isAddGuest} />
          {:else}
            <div class="actions">
              <Button action={() => (isAddGuest = true)}>
                <Label text="Ajouter un invité" icon="user-plus" h="2em" />
              </Button>
            </div>
          {/if}
          <GuestsList
            {wedding_guid}
            {search}
            guests={filtered_guests}
            {created_id}
            on:refresh={refresh}
            on:refresh_count={() => refresh_count(wedding_guid)} />
        {:else if isGraphView}
          <span>TODO GraphView</span>
        {/if}
      </article>
    </HStack>
  </Background>
  <Copyright company="KiwisApp" />
</main>

<style>
  article {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    flex: 1 1 auto;
    margin-left: 1em;
    margin-right: 1em;
  }

  div.menu {
    background-color: var(--primary-color);
    color: var(--on-primary-color);
  }

  div.search {
    border-radius: 10px;
    border: 1px solid var(--primary-color);
    background: #efefef;
    padding: 3px;
    display: flex;
  }

  div.actions {
    margin-top: 5px;
    margin-bottom: 5px;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    border-radius: 5px;
  }

  .actions:hover {
    background-color: rgb(235, 236, 240);
  }
</style>
